<template>
  <div id="app" class="zj-app">
    <!-- 预警弹窗提醒 -->
    <!-- <ElaryWarningBox :warningId.sync="warningId"></ElaryWarningBox> -->
    <Communicate v-show="CommunicateVisible"></Communicate>
    <WarningNotification
      :warningId.sync="warningId"
      v-if="isLogin && isInit && !isEmergency"
    ></WarningNotification>
    <div class="zj-app-box" v-if="isLogin && isInit">
      <zj-dynamic-container
        class="zj-app-header"
        v-if="THM('header.visiable', true)"
        :view="ui.header"
        :viewData="THM('header.style', {})"
      />
      <div class="zj-app-body">
        <zj-dynamic-container
          class="zj-app-sidemenu zj-app-sidemenu-left"
          v-if="isSideMenuVisiable"
          :view="ui.sidemenu"
        />
        <zj-dynamic-container
          class="zj-app-workspace"
          :class="{ 'zj-app-bg': isShowbgImg }"
          :view="ui.workspace"
        />
      </div>
      <zj-dynamic-container
        class="zj-app-footer"
        v-if="THM('footer.visiable', true)"
        :view="ui.footer"
      />
    </div>
    <zj-startup
      v-if="isLogin && !isInit"
      :percent="startup.percent"
      :msg="startup.msg"
    />
    <!--<zj-login v-if="!isLogin" @login="onLogin" />-->
    <component :is="ui.login" v-if="!isLogin" @login="onLogin" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import utils from "../utils";
import ZJApis from "../api";
import WebSocketApi from "../websoket/intercomWebsocket";
import websoket from "../utils/src/websocket";
// import ComponentUserOrgControlVue from '../../../bei0717/clientweb/src/plugins/emergency/src/views/src/EmergencyOperations/Components/Component-UserOrgControl.vue';
// import ElaryWarningBox from "../plugins/serviceAlarm/src/views/src/elaryWarning/ElaryWarningBox"
const strNumber = global.$config.api.strNumber;
const strPassword = global.$config.api.strPassword;
const strLocalIP = global.$config.api.strLocalIP;
const strServer = global.$config.api.strServer;
export default {
  name: "ZjApp",
  componentName: "ZjApp",
  components: {
    // ElaryWarningBox
  },
  data() {
    return {
      isInit: false,
      ui: {
        login: "ZjLogin",
        header: "ZjHeader",
        sidemenu: "ZjSideMenu",
        footer: "ZjFooter",
        workspace: "ZjWorkSpace",
      },
      startup: {
        percent: 0,
        msg: "启动中...",
      },
      warningId: "",
      ws: null,
      InitTimer: "",
      deptArray: [] /*用户部门列表*/,
      userStateArray: [] /*用户状态列表*/,
      //声明一个变量来注册监听事件
      getSocketData: null,
      pttGroupArray: [] /*对讲组列表*/,
      pttGroupMembersArray: [] /*对讲组成员列表*/,
      groupList: [],
      showGroup: [],
      LoginSend: {
        strNumber: strNumber,
        strPassword: strPassword,
        strLocalIP: strLocalIP,
        strServer: strServer,
      },
      CommunicateVisible: false,
      isEmergency: false,
    };
  },
  computed: {
    currentNavMenu() {
      return this.menu.currentNavMenu;
    },
    currentMenu() {
      return this.menu.currentMenu;
    },
    isSideMenuVisiable() {
      return (
        this.THM("sidemenu.visiable", true) &&
        this.currentNavMenu &&
        this.currentNavMenu.MenuInfos &&
        this.currentNavMenu.MenuInfos.length
      );
    },
    ...mapGetters(["isShowbgImg"]),
  },
  created() {
    let loginComponent = "";
    if (
      utils.getQueryString("userName") == undefined ||
      utils.getQueryString("userName") == "" ||
      utils.getQueryString("userName") == null
    ) {
      loginComponent = "ZjEmergencyLogin";
    } else {
      loginComponent = this.CNF("ui.loginComponent", null);
    }

    if (loginComponent) {
      this.ui.login = loginComponent;
    }
    //如果是应急平台则不弹出消息弹窗
    if (localStorage.getItem("isEmergency") == "true") {
      this.isEmergency = true;
    } else {
      this.isEmergency = false;
    }

    // var mainUrl="http://biaozhunhua.zjht100.com/tsscdataview";
    // window.location.href = mainUrl;
    this.$on("nav-click", this.onNavClick);
    this.$on("sidemenu-select", this.onMenuSelect);
    this.$on("sidemenu-open", this.onMenuOpen);
    this.$on("sidemenu-close", this.onMenuClose);
    this.$on("select-nav", this.selectNavMenu);
    this.$on("select-sidemenu", this.selectSideMenu);
    if (this.isLogin) {
      if (this.CNF("app.isBiaoZhunHua")) {
        this.initBiaoZhunHua();
      } else {
        this.init();
      }
    }
    if (document) {
      document.title = this.THM("header.title.text", this.CNF("app.name"));
    }

    this.isNotifyClosed = false;
    this.$notify.on("close", () => {
      if (!this.isNotifyClosed) {
        this.isNotifyClosed = true;
        this.$message({
          message: "消息服务已断开",
          type: "error",
        });
      }
    });
    this.$notify.on("open", () => {
      if (this.isNotifyClosed) {
        this.isNotifyClosed = false;
        this.$message({
          message: "消息服务已连接",
          type: "success",
        });
      }
    });
  },
  mounted() {
    // 预警弹窗提醒
    this.$notify.subscript(
      "msgkey_business_alarm", //订阅消息的key
      (x) => this.onRecv(x)
    );

    console.debug("Subscript: msgkey_business_alarm");
    // this.InitWebSocket();
    this.initWebsocket();
      //    let route = {"system":"大数据","route":"/sys-scenic-imclient/PP1614671751650154/PP1614672717513224","param":{"action":"切换当日","extra":["开始时间","结束时间"]}}
      // this.$router.push(route.route)
      // alert(9)

    this.getSocketMessage();
  },
  methods: {
    InitWebSocket() {
      this.ws = WebSocketApi.OpenWebsoket(this.LoginSend);
    },
    initWebsocket(){
      let that= this;
      console.log("initWebsocket--")
      console.log("websoket.state")
      console.log(websoket.state)
       if(websoket.state.timerHeart){
          websoket.ws.onmessage=(messages)=>{
            console.log("messages============")
            console.log(messages)
              if(messages&&messages.data){
                console.log(messages.data)
                let route = JSON.parse(messages.data)
                console.log(route)
                // 调用公共的路由跳转方法
                if (route.system) {
                  that.handleRouteJump(route);
                }
              }
          }
       }else{
           websoket.createWebSocket();
            websoket.ws.onmessage=(messages)=>{
            console.log("messages============2222")
            console.log(messages)
               if(messages&&messages.data){
                console.log(messages.data)
                let route = JSON.parse(messages.data)
                console.log("route is :========")
                console.log(route)
                // 调用公共的路由跳转方法
                if (route.system) {
                  that.handleRouteJump(route);
                }
              }
          }
       }},

    getSocketMessage() {
      // 创建接收消息函数
      this.getSocketData = (e) => {
        let msgdat = e && e.detail.data;
        //这边编写处理服务端消息代码
        if (msgdat) {
          var arrInfo = msgdat.split(":");

          if (arrInfo.length == 2) {
            // if (arrInfo[0] == "OnErrorMessage") {
            //   this.getErrInfo(arrInfo[1]);
            // }
            if (arrInfo[0] == "OnStartVideoPlayer") {
              this.CommunicateVisible = true;
            } else if (arrInfo[0] == "OnPhoneLineState") {
              this.CommunicateVisible = true;
            }
          }
        }
      };
      //注册监听事件
      window.addEventListener("onmessageWS", this.getSocketData);
    },
    getErrInfo(status) {
      let statusName = WebSocketApi.GetErrcodeString(status);
      if (statusName) {
        this.$message({
          type: "error",
          message: statusName,
        });
      }
    },
    onRecv(x) {
      var content = x.firstBlock().text;
      console.log("报警内容", content);
      // content = "f090afae-ae71-4ef4-9bdd-6af610aa5fb3";
      if (content) {
        this.warningId = content;
      }
    },
    onNavClick(menuId) {
      const m = this.menu.findMenuByMenuId(menuId);
      this.$router.onNavClick(m);
    },

    onMenuOpen(menuId) {
      const m = this.menu.findMenuByMenuId(menuId);
      this.$router.onMenuOpen(m);
    },

    onMenuClose(menuId) {
      const m = this.menu.findMenuByMenuId(menuId);
      this.$router.onMenuClose(m);
    },

    onMenuSelect(menuId) {
      const m = this.menu.findMenuByMenuId(menuId);
      this.$router.onMenuSelect(m);
    },

    // 登录成功
    onLogin(user) {
      this.$emit("login", user);
      this.$zjapp.emit("login", {
        user: user,
      });
      if (this.CNF("app.isBiaoZhunHua")) {
        this.initBiaoZhunHua();
      } else {
        this.init();
      }
    },

    selectNavMenu(menu) {
      console.log("selectNavMenu", menu);
      this.menu.currentNavMenu = menu;
    },

    selectSideMenu(menu) {
      console.log("selectSideMenu", menu);
      this.menu.currentMenu = menu;
    },
    //标准化方式登录初始化
    initBiaoZhunHua() {
      let user = this.user.userInfo;
      this.startup.percent = 50;
      this.startup.msg = "初始化...";
      let leftArr = [];
      //不改变原数组
      const leftMenus = JSON.parse(JSON.stringify(user.left));
      for (let i in leftMenus) {
        leftArr.push(leftMenus[i]); //属性
        //arr.push(obj[i]); //值
      }
      let leftMenuArr = [];
      for (let i in leftArr) {
        if (leftArr[i].length > 0) {
          leftMenuArr = leftMenuArr.concat(utils.flattenArray(leftArr[i]));
        }
      }
      let menuArr = leftMenuArr.concat(user.top || []);

      const subMenuArr = menuArr.map((item) => {
        return {
          MenuId: item.code,
          ParentMenuId: item.parentCode || this.CNF("app.menu_code"),
          MenuUrl: item.url,
          MenuCode: item.code,
          Id: item.id,
          MenuIndex: item.orderNum,
          MenuName: item.name,
          MenuImg: item.image,
          Description: item.description,
          CreateTime: item.createdate,
          ModifyTime: item.modifydate,
        };
      });

      const topArr = [
        {
          MenuId: this.CNF("app.menu_code"),
          ParentMenuId: "",
          MenuUrl: "",
          MenuCode: this.CNF("app.menu_code"),
          Id: 0,
          MenuIndex: 0,
          MenuName: this.CNF("app.name"),
          MenuImg: "",
          Description: "",
          CreateTime: "",
          ModifyTime: "",
        },
      ];
      const menus = this.convertToTreeNodes(topArr.concat(subMenuArr));
      this.menu.setMenu({ ...menus[0] } || {}, this.config);

      const userArr = [user.user];
      const users = userArr.map((item) => {
        return {
          Id: item.id,
          UserId: item.code,
          UserName: item.userName,
          Phone: item.phone,
          Description: item.description,
          CreateTime: item.createdate,
          Creater: item.creater,
          ModifyTime: item.modifydate,
          Modifier: item.modefier,
          OrgId: item.organizationCode,
        };
      });

      const departmentArr = user.organization;
      const departs = departmentArr.map((item) => {
        return {
          Id: item.id,
          OrgId: item.code,
          OrgName: item.name,
          Description: item.description,
          CreateTime: item.createdate,
          Creater: item.creater,
          ModifyTime: item.modifydate,
          Modifier: item.modefier,
        };
      });

      let u = { ...users[0] } || {};
      u.Roles = user.user.roleList || [];
      u.Role = [];
      u.Departments = departs || [];
      u.userInfo = this.user.userInfo;
      this.user.setUser(u);
      this.initRouter();

      this.startup.percent = 100;
      this.startup.msg = "启动中...";
      this.$router.firstSetup(this);
      this.isInit = true;
      this.$zjapp.emit("started", {
        user: this.user,
        menu: this.menu,
        config: this.config,
      });
    },
    //转换数据适应本系统数据格式
    jsonToArray(nodes) {
      var r = [];
      if (Array.isArray(nodes)) {
        for (var i = 0, l = nodes.length; i < l; i++) {
          r.push(nodes[i]); // 取每项数据放入一个新数组
          if (
            Array.isArray(nodes[i]["children"]) &&
            nodes[i]["children"].length > 0
          )
            // 若存在children则递归调用，把数据拼接到新数组中，并且删除该children
            r = r.concat(this.jsonToArray(nodes[i]["children"]));
          delete nodes[i]["children"];
        }
      }
      return r;
    },

    convertToTreeNodes(dataList) {
      let formatObj = dataList.reduce((pre, cur) => {
        return { ...pre, [cur["MenuId"]]: cur };
      }, {});

      let formatArray = dataList.reduce((arr, cur) => {
        let pid = cur.ParentMenuId ? cur.ParentMenuId : 0;
        let parent = formatObj[pid];
        if (parent) {
          parent.MenuInfos
            ? parent.MenuInfos.push(cur)
            : (parent.MenuInfos = [cur]);
        } else {
          arr.push(cur);
        }
        return arr;
      }, []);
      return formatArray;
      // this.convertToTreeNodesfunction(formatArray);
    },

    // 初始化
    // 处理路由跳转逻辑（抽取为公共方法）
    handleRouteJump(route) {
        // 获取当前系统配置
        const currentSystem = window.$config && window.$config.app && window.$config.app.systemName;
        const msgSystem = route.system;
        
        // 检查extra参数是否存在且不为空
        const hasValidExtra = route.param && route.param.extra && route.param.extra.length > 0;
        const extraParam = hasValidExtra ? route.param.extra[0] : null;
        
        // 判断是否为本系统消息
        if (currentSystem && msgSystem && msgSystem === currentSystem) {
            // 本系统内跳转，使用vue router
            const routerParams = {
                path: route.route
            };
            
            // 如果有有效的extra参数，才添加query
            if (hasValidExtra) {
                routerParams.query = {name: extraParam};
            }
            
            this.$router.push(routerParams);
        } else {
            // 跨系统跳转，使用window.location.href
            let targetUrl = '';
            const msgUrl = window.$config && window.$config.api && window.$config.api.msg_url;
            
            // 构建基础URL
            if (msgSystem === '大数据') {
                // 大数据系统，拼接/dataview
                targetUrl = `${msgUrl}/dataview/#${route.route}`;
            } else {
                // 其他系统，直接跳转
                targetUrl = route.route;
            }
            
            // 如果有有效的extra参数，才添加查询字符串
            if (hasValidExtra) {
                targetUrl += `?name=${encodeURIComponent(extraParam)}`;
            }
            
            window.location.href = targetUrl;
        }
    },
    
    init() {
      return utils
        .waitAll([
          () => this.fetchUserDetails(),
          (r) => this.menu.setMenu(r[0].menu, this.config),
          () => this.initRouter(),
        ])
        .then(() => {
          this.startup.percent = 100;
          this.startup.msg = "启动中...";
          this.$router.firstSetup(this);
          this.isInit = true;
          this.$zjapp.emit("started", {
            user: this.user,
            menu: this.menu,
            config: this.config,
          });
        });
    },

    // 获取用户详细资料、用户菜单、用户角色、用户部门
    fetchUserDetails() {
      let user = this.user;
      let userId = user.UserId;
      return utils.waitAll(
        [
          // 用户资料
          () => {
            this.startup.percent = 0;
            this.startup.msg = "获取用户资料...";
            return new ZJApis.UserApi().GetItemById({
              UserId: userId,
            });
          },
          // 用户角色
          () => {
            this.startup.percent = 25;
            this.startup.msg = "获取用户角色...";
            return new ZJApis.UserRoleApi().GetByUserId({
              UserId: userId,
            });
          },
          // 角色名称
          (r) => {
            let arr = [];
            let api = new ZJApis.RoleApi();
            let roles = r[1].data.Data || [];
            for (let i = 0; i < roles.length; i++) {
              arr.push(
                api.GetItemById({
                  RoleId: roles[i].RoleId,
                })
              );
            }
            let filter = (d) =>
              utils.each(d, (v, i) => (roles[i].RoleName = v.RoleName));
            return utils.waitAll(arr, filter);
          },

          // 用户菜单
          () => {
            this.startup.percent = 50;
            this.startup.msg = "获取用户菜单...";
            return new ZJApis.UserApi().GetUserAuth({
              LoginName: user.LoginName,
              MenuCode: this.CNF("app.menu_code"),
              ProductCode: this.CNF("app.product_code"),
            });
          },
          // 用户部门
          () => {
            this.startup.percent = 60;
            this.startup.msg = "获取用户部门...";
            return new ZJApis.OrgUserApi().FindUserCompany({
              UserId: userId,
            });
          },
        ],
        (r) => {
          let u = r[0].data.Data || {};
          u.Roles = r[1].data.Data || [];
          u.Role = r[2] || [];
          u.Departments = r[4].data.Data || [];
          if (typeof u.LoginPwd !== "undefined") {
            delete u.LoginPwd;
          }
          const rv = {
            user: u,
            menu: r[3].data.Data || {},
          };
          this.user.setUser(rv.user);
          this.startup.percent = 75;
          return rv;
        }
      );
    },

    initRouter() {
      this.startup.msg = "解析菜单配置...";
      return this.$router.loadUserMenus(this.user, this.menu, this.config);
    },
  },
  destroyed() {
    //移除监听器
    window.removeEventListener("onmessageWS", this.getSocketData);
  },
};
</script>